import { LoaderFunction } from 'react-router-dom';

import { LearningPathsHubLoaderProps } from 'src/pages/hubs/LearningPathPage/loader';

export const getAccreditedData = {
  hero: {
    titleExternal: 'Get Accredited',
    subtitle:
      'Accreditations provide individuals with Atlassian-specific subject matter expertise tailored to their role in either Sales or Technical Delivery. Each Accreditation is designed to enhance your skills and assess your knowledge within your role and area of expertise. Explore the solution-specific accreditation paths below to broaden your Atlassian subject matter expertise.',
    eyebrowText: '',
  },
  linkedContentBlockCollection: {
    items: [
      {
        sys: { id: 'accreditations' },
        titleExternal: '',
        subtitle: '',
        asset: null,
        associatedContentResourcesCollection: {
          items: [
            {
              __typename: 'AssociatedContent' as const,
              sys: { id: 'enterprise-strategy-planning' },
              nameInternal: 'Enterprise Strategy & Planning Accreditations',
              title: 'Enterprise Strategy & Planning Accreditations',
              description:
                "These trainings teach Atlassian's Enterprise Strategy & Planning tools including, Align, Focus, and more, along with best practices from Scaled Agile, for both Sales and Technical Delivery roles.",
              contentType: 'certification',
              link: {
                link: globalThis?.location?.href,
                label: 'Enterprise Strategy & Planning Accreditations',
                target: '_self',
              },
            },
            {
              __typename: 'AssociatedContent' as const,
              sys: { id: 'cloud-migration' },
              nameInternal: 'Cloud Migration Accreditations',
              title: 'Cloud Migration Accreditations',
              description:
                'Atlassian customers are landing in or planning to migrate to our cloud offerings, and this set of Cloud Accreditations will provide you with tools to qualify, discovery, position, sell, and migrate, customers from their server or Data Center instances to our cloud products with Sales, Technical Sales, and Technical Delivery roles.',
              contentType: 'certification',
              link: {
                link: globalThis?.location?.href,
                label: 'Cloud Migration Accreditations',
                target: '_self',
              },
            },
            {
              __typename: 'AssociatedContent' as const,
              sys: { id: 'service-management' },
              nameInternal: 'Service Management Accreditations',
              title: 'Service Management Accreditations',
              description:
                "This collection of training programs introduces learners to Atlassian's perspective and solutions on IT Service Management and how to sell, design, and implement them. Learners will have the opportunity to earn accreditations for both Sales and Technical Delivery roles.",
              contentType: 'certification',
              link: {
                link: globalThis?.location?.href,
                label: 'Service Management Accreditations',
                target: '_self',
              },
            },
            {
              __typename: 'AssociatedContent' as const,
              sys: { id: 'software-development' },
              nameInternal: 'Software Development Accreditations',
              title: 'Software Development Accreditations',
              description:
                "Atlassian tools enhance product development teams' experience, recognizing every company as a tech product company. The Software Development accreditations equip partners with skills to showcase Atlassian tool benefits to software developers, product owners, and tech managers and to deliver and implement Software Development and Open Toolchain solutions for product teams.",
              contentType: 'certification',
              link: {
                link: globalThis?.location?.href,
                label: 'Software Development Accreditations',
                target: '_self',
              },
            },
            {
              __typename: 'AssociatedContent' as const,
              sys: { id: 'teamwork-foundations' },
              nameInternal: 'Teamwork Foundations Accreditations',
              title: 'Teamwork Foundations Accreditations',
              description:
                "The Teamwork Foundation Sales Accreditation equips sellers and technical sellers to position and demonstrate the value of the Teamwork Foundations solution. It prepares partners to lead strategic customer conversations around transforming work, aligning goals, standardizing practices, and leveraging AI. Learners gain skills in Atlassian's selling approach, the System of Work narrative, and solution selling, while learning to access key resources and use the SoW and Teamwork Graph in enterprise deals.",
              contentType: 'certification',
              link: {
                link: globalThis?.location?.href,
                label: 'Teamwork Foundations Accreditations',
                target: '_self',
              },
            },
          ],
        },
      },
    ],
  },
} as unknown as LearningPathsHubLoaderProps['learningPathsHubData'];

export const maintainAccreditationData = {
  hero: {
    titleExternal: 'Maintain Your Accreditation',
    subtitle:
      'Explore the available Accreditation Maintenance packages below, including their due, as well as those Accreditation Maintenance Packages launching soon! Failure to complete the maintenance package by the deadline will result in suspension of your accreditation. Learn more (https://atlassianpartners.atlassian.net/wiki/x/KAJOGw).* The maintenance packages listed as past due below do not indicate your personal accreditation status. To check if any action is required on your part, please click on the maintenance package link below. This will help you determine if any additional coursework is necessary to complete your accreditation maintenance package.',
    eyebrowText: '',
  },
  linkedContentBlockCollection: {
    items: [
      {
        sys: { id: 'accreditation-maintenance' },
        titleExternal: '',
        subtitle: '',
        asset: null,
        associatedContentResourcesCollection: {
          items: [
            {
              __typename: 'AssociatedContent' as const,
              sys: { id: 'enterprise-strategy-planning-sales-maintenance' },
              nameInternal: 'Enterprise Strategy & Planning Sales Accreditation Maintenance',
              title: 'Enterprise Strategy & Planning Sales Accreditation Maintenance',
              description:
                'Launches: August 1st | Due: October 31st. Act now to complete by January 31st. to avoid Accreditation suspension',
              contentType: 'certification',
              link: {
                link: globalThis?.location?.href,
                label: 'Enterprise Strategy & Planning Sales Accreditation Maintenance',
                target: '_self',
              },
            },
            {
              __typename: 'AssociatedContent' as const,
              sys: { id: 'cloud-migration-technical-delivery-maintenance' },
              nameInternal: 'Cloud Migration Technical Delivery Accreditation Maintenance',
              title: 'Cloud Migration Technical Delivery Accreditation Maintenance',
              description:
                'Launches: August 1st | Due: October 31st. Act now to complete by January 31st. to avoid Accreditation suspension',
              contentType: 'certification',
              link: {
                link: globalThis?.location?.href,
                label: 'Cloud Migration Technical Delivery Accreditation Maintenance',
                target: '_self',
              },
            },
            {
              __typename: 'AssociatedContent' as const,
              sys: { id: 'enterprise-strategy-planning-technical-delivery-maintenance' },
              nameInternal: 'Enterprise Strategy & Planning Technical Delivery Accreditation Maintenance',
              title: 'Enterprise Strategy & Planning Technical Delivery Accreditation Maintenance',
              description: 'Launches: May 1st | Due: July 31st',
              contentType: 'certification',
              link: {
                link: globalThis?.location?.href,
                label: 'Enterprise Strategy & Planning Technical Delivery Accreditation Maintenance',
                target: '_self',
              },
            },
            {
              __typename: 'AssociatedContent' as const,
              sys: { id: 'software-development-sales-maintenance' },
              nameInternal: 'Software Development Sales Accreditation Maintenance',
              title: 'Software Development Sales Accreditation Maintenance',
              description: 'Launches: May 1st | Due: July 31st',
              contentType: 'certification',
              link: {
                link: globalThis?.location?.href,
                label: 'Software Development Sales Accreditation Maintenance',
                target: '_self',
              },
            },
            {
              __typename: 'AssociatedContent' as const,
              sys: { id: 'service-management-technical-delivery-maintenance' },
              nameInternal: 'Service Management Technical Delivery Accreditation Maintenance',
              title: 'Service Management Technical Delivery Accreditation Maintenance',
              description: 'Launches: November 1st | Due: January 31st',
              contentType: 'certification',
              link: {
                link: globalThis?.location?.href,
                label: 'Service Management Technical Delivery Accreditation Maintenance',
                target: '_self',
              },
            },
            {
              __typename: 'AssociatedContent' as const,
              sys: { id: 'cloud-migration-sales-maintenance' },
              nameInternal: 'Cloud Migration Sales Accreditation Maintenance',
              title: 'Cloud Migration Sales Accreditation Maintenance',
              description: 'Launches: November 1st | Due: January 31st',
              contentType: 'certification',
              link: {
                link: globalThis?.location?.href,
                label: 'Cloud Migration Sales Accreditation Maintenance',
                target: '_self',
              },
            },
            {
              __typename: 'AssociatedContent' as const,
              sys: { id: 'service-management-sales-maintenance' },
              nameInternal: 'Service Management Sales Accreditation Maintenance',
              title: 'Service Management Sales Accreditation Maintenance',
              description: 'Launches: February 1st | Due: April 30th',
              contentType: 'certification',
              link: {
                link: globalThis?.location?.href,
                label: 'Service Management Sales Accreditation Maintenance',
                target: '_self',
              },
            },
            {
              __typename: 'AssociatedContent' as const,
              sys: { id: 'software-development-technical-delivery-maintenance' },
              nameInternal: 'Software Development Technical Delivery Accreditation Maintenance',
              title: 'Software Development Technical Delivery Accreditation Maintenance',
              description: 'Launches: February 1st | Due: April 30th',
              contentType: 'certification',
              link: {
                link: globalThis?.location?.href,
                label: 'Software Development Technical Delivery Accreditation Maintenance',
                target: '_self',
              },
            },
          ],
        },
      },
    ],
  },
} as unknown as LearningPathsHubLoaderProps['learningPathsHubData'];

export const loader: LoaderFunction = async ({ params }): Promise<LearningPathsHubLoaderProps> => {
  if (params.hubName === 'get-accredited') {
    return { learningPathsHubData: getAccreditedData };
  }

  if (params.hubName === 'maintain-your-accreditation') {
    return { learningPathsHubData: maintainAccreditationData };
  }

  throw new Error('Not Found');
};
